document.addEventListener('DOMContentLoaded', function () {
  function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function openModal(targetId) {
    var modal = document.getElementById(targetId);
    if (modal) {
      modal.classList.add('is-active');
      document.documentElement.classList.add('overflow-hidden');
    }
  }

  function closeModal(modal) {
    modal.classList.remove('is-active');
    document.documentElement.classList.remove('overflow-hidden');
  }

  document.querySelectorAll('[data-popup-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-popup-open'));
    });
  });

  document.querySelectorAll('[data-popup-close]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var modal = button.closest('.custom-popup-modal');
      if (modal) closeModal(modal);
    });
  });

  document.querySelectorAll('.custom-popup-modal').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.classList.contains('custom-popup-modal__overlay')) {
        closeModal(modal);
      }
    });
  });

  var utmSource = getParam('utm_source');
  var utmMedium = getParam('utm_medium');

  if (utmSource === 'line' && utmMedium !== 'cpc') {
    sessionStorage.setItem('acs', 'on');
  } else {
    if (sessionStorage.getItem('acs') === null) {
      setTimeout(function () {
        sessionStorage.setItem('acs', 'on');
        var trigger = document.getElementById('popup-open-line');
        if (trigger) trigger.click();
      }, 3000);
    }
  }

  if (sessionStorage.getItem('acs-campaign') === null) {
    setTimeout(function () {
      sessionStorage.setItem('acs-campaign', 'on');
      var trigger = document.getElementById('popup-open-campaign');
      if (trigger) trigger.click();
    }, 3000);
  }

  var popupMini = document.getElementById('popup_mini');
  if (popupMini) {
    var closeMini = popupMini.querySelector('.custom-popup-mini__close');

    if (sessionStorage.getItem('popup_mini') === null) {
      popupMini.style.display = 'block';
    }

    if (closeMini) {
      closeMini.addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('popup_mini', 'on');
        popupMini.style.display = 'none';
      });
    }
  }
});